import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import "tailwindcss/tailwind.css";
import { Empty } from "antd";
import "../../../../src/styles.css";
import Vectorsorting from "../../../assets/Vectorsorting.svg";
import { useTranslation } from "react-i18next";
import { Navigate, useNavigate } from "react-router-dom";
import arrowright from "../../../assets/arrowright.svg";
import ShimmerLoader from "../../../loading";
import CustomPagination from "../../../components/CustomWidgets/CustomPagination";
import { useSelector } from "react-redux";


const InventorySaleSummaryTable = ({ additionalData, pagination, onRowClick }) => {
  const { t, i18n } = useTranslation();
  const [flag, setflag] = useState(false);
  const navigate = useNavigate();

  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store
  );



  const openOrderList = (id) => {
    navigate(`/vendorDetails?id=${id}`);
  };

  const data = useMemo(
    () =>
      //   additionalData?.status
      //     ? additionalData?.all_product
      additionalData || [],
    [additionalData]
  );

  useEffect(() => {
    if (additionalData?.length === 0 && !flag) {
      const timer = setTimeout(() => {
        setflag(true);
      }, 3000);

      return () => clearTimeout(timer);
    }

  }, [additionalData, flag]);

  const columns = useMemo(
    () => [
      {
        Header: (
          <div className="text-start justify-start" title={t("Date & Time")}>
            {t("Date & Time")}
          </div>
        ),
        width: "6%", // Add this line
        accessor: "sale_date",
        headerClassName: "text-start",
        Cell: ({ row }) => (
          <div className="text-start justify-start">{row.original.sale_date}</div>
        ),
      },
      {
        Header: (
          <div className="text-start justify-start" title={t("Order Type")}>
            {t("Order Type")}
          </div>
        ),
        width: "6%", // Add this line
        accessor: "order_type",
        headerClassName: "text-start",
        Cell: ({ row }) => (
          <div className="text-start justify-start">{t(row.original.order_type)}</div>
        ),
      },
      {
        Header: (
          <div className="text-start justify-start" title={t("Barcode")}>
            {t("Barcode")}
          </div>
        ),
        width: "6%", // Add this line
        accessor: "barcode",
        headerClassName: "text-start",
        Cell: ({ row }) => (
          <div className="text-start justify-start">{row.original.barcode}</div>
        ),
      },

      {
        Header: (
          <div className="text-start" title={t("Product Name")}>
            {t("Product Name")}
          </div>
        ),
        width: "10%", // Add this line
        accessor: "product_name",
        Cell: ({ row }) => (
          <div className="text-start">{`${row.original.product_name}`}</div>
        ),
      },
{
        Header: (
          <div className="text-start" title={t("Product Groups")}>
            {t("Product Groups")}
          </div>
        ),
        width: "10%", // Add this line
        accessor: "group_name",
        Cell: ({ row }) => (
          <div className="text-start">{`${row.original.group_name}`}</div>
        ),
      },

      // {
      //   Header: (
      //     <div className="text-start justify-start" title={t("category")}>
      //       {t("category")}
      //     </div>
      //   ),
      //   width: "5%", // Add this line
      //   accessor: "category",
      //   headerClassName: "text-start",
      //   Cell: ({ row }) => (
      //     <div className="text-start justify-start">{row.original.category}</div>
      //   ),
      // },

      // {
      //   Header: (
      //     <div className="text-start" title={t("Sub-Category")}>
      //       {t("Sub-Category")}
      //     </div>
      //   ),
      //   width: "7%", // Add this line
      //   accessor: "sub_category",
      //   Cell: ({ row }) => (
      //     //   <div className="text-start">{`${row.original.customer_name ? row.original.customer_name : ''} (${row.original.customer_phone})`}</div>
      //     <div className="text-start">{row.original.sub_category}</div>
      //   ),
      // },

      {
        Header: (
          <div className="text-start" title={t("Quantity Sold")}>
            {t("Quantity Sold")}
          </div>
        ),
        width: "6%", // Add this line
        accessor: "qty_sold",
        Cell: ({ row }) => (
          <div className="text-start">{row.original.qty_sold}</div>
        ),
      },
      {
        Header: (
          <div className="text-start" title={t("Total Cost")}>
            {t("Total Cost")}
          </div>
        ),
        width: "5%", // Add this line
        accessor: "total_cost",
        Cell: ({ row }) => (
          <div className="text-start">EGP {row.original.total_cost?.toFixed(2)}</div>
        ),
      },
      {
        Header: (
          <div className="text-start" title={t("Total Value")}>
            {t("Total Value")}
          </div>
        ),
        width: "5%", // Add this line
        accessor: "total_value",
        Cell: ({ row }) => (
          <div className="text-start">EGP {row.original.total_value}</div>
        ),
      },
      // {
      //   Header: (
      //     <div className="text-start" title={t("Payment Type")}>
      //       {t("Payment Type")}
      //     </div>
      //   ),
      //   width: "8%", // Add this line
      //   accessor: "payment",
      //   Cell: ({ row }) => (
      //     <div className="text-start">{t(row.original.payment)}</div>
      //   ),
      // },
      {
        Header: (
          <div className="text-start" title={t("Payment Method")}>
            {t("Payment Method")}
          </div>
        ),
        width: "7%", // Add this line
        accessor: "payment_method",
        Cell: ({ row }) => (
          <div className="text-start">{t(row.original.payment_method)}</div>
        ),
      },
      {
        Header: (
          <div className="text-start" title={t("Profit")}>
            {t("Profit")}
          </div>
        ),
        width: "4%", // Add this line
        accessor: "profit",
        Cell: ({ row }) => (
          <div className={`text-start`}>{row.original.profit}</div>
        ),
      },
      {
        Header: (
          <div className="text-start" title={t("Profit %")}>
            {t("Profit %")}
          </div>
        ),
        width: "4%", // Add this line
        accessor: "profit_percentage",
        Cell: ({ row }) => (
          <div className={`text-start`}>  {row.original.profit_percentage != null ? `${row.original.profit_percentage}%` : "--"}
          </div>
        ),
      },

      ...(allStores
        ? [
          {
            Header: (
              <div className="text-start" title={t("Store Name")}>
                {t("Store Name")}
              </div>
            ),
            width: "8%", // Add this line
            accessor: "store_name",
            Cell: ({ row }) => (
              <div className="text-start">{row.original.store_name}</div>
            ),
          },
        ]
        : []),
    ],
    [t]
  );


  const {
    headerGroups,
    prepareRow,
    page,
    nextPage,
    setPageSize,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data: data,
      initialState: { pageSize: 10 },
    },
    useSortBy,
    usePagination,
    useRowSelect
  );

  const [pageIndex, setpageIndex] = useState(1);

  useEffect(() => {
    const pageDetails = {
      limit: pageSize,
      offset: pageSize * (pageIndex - 1) < 0 ? 0 : pageSize * (pageIndex - 1),
    };

    if (pageSize) pagination(pageDetails);
  }, [pageSize, pageIndex]);

  const handlePageSizeChange = (newPageSize) => {
    // Ensure the current page doesn't exceed the total available pages
    const maxPageIndex = Math.ceil(data.length / newPageSize);
    if (pageIndex > maxPageIndex) {
      setpageIndex(maxPageIndex); // Adjust the pageIndex to the last available page
    }

    setPageSize(newPageSize);
  };

  return (
    <>
      <div
        className="container flex flex-col mx-auto mt-4"
        style={{ maxWidth: "100%" }}
      >
        {additionalData?.length == 0 && flag == false ? (
          <div className="h-screen w-[90%] mt-2 ">
            <ShimmerLoader />
          </div>
        ) : (
          <>
            {/* Header Table (Fixed) */}
            <div>
              <table
                className="font-normal  max-w-[100%] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                style={{ tableLayout: "fixed" }}
              >
                <thead>
                  {headerGroups.map((headerGroup, headerIndex) => {
                    const { key: headerKey, ...headerGroupProps } =
                      headerGroup.getHeaderGroupProps();
                    return (
                      <tr
                        key={headerKey}
                        {...headerGroupProps}
                        className="bg-[#78CFEC66] text-sm font-semibold overflow-hidden whitespace-nowrap"
                      >
                        {headerGroup.headers.map((column, colIndex) => {
                          const { key: columnKey, ...columnProps } =
                            column.getHeaderProps(
                              column.getSortByToggleProps()
                            );
                          return (
                            <th
                              key={columnKey}
                              {...columnProps}
                              className="py-3 whitespace-nowrap"
                              style={{ width: column.width }} // Set column width
                            >
                             <div className="flex flex-row items-center ms-2 text-sm leading-tight ">
                                                                                     {column.render("Header")}
                                                                                     {column.canSort && (
                                                                                             <span className="ms-1">
                                                                                       {column.isSorted ? (
                                                                                         column.isSortedDesc ? (
                                                                                           <img
                                                                                             src={Vectorsorting}
                                                                                             style={{ minHeight: 10, minWidth: 10 }}
                                                                                             alt="vector"
                                                                                           />
                                                                                         ) : (
                                                                                           <img
                                                                                             className="rotate-180"
                                                                                             src={Vectorsorting}
                                                                                             alt="vector"
                                                                                           />
                                                                                         )
                                                                                       ) : (
                                                                                         // 👇 Show a neutral icon when column is not sorted
                                                                                         <img
                                                                                           src={Vectorsorting}
                                                                                           alt="sortable"
                                                                                           style={{ minHeight: 10, minWidth: 10, opacity: 0.3 }}
                                                                                         />
                                                                                       )}
                                                                       
                                                                                     </span>
                                                                                     )}
                                                                                     </div>
                            </th>
                          );
                        })}
                      </tr>
                    );
                  })}
                </thead>
              </table>
            </div>

            {/* Body Table (Scrollable) */}
            <div
              className="scrollbar-none bg-white"
              style={{
                overflowY: "auto",
                maxHeight: "600px", // Adjust height as needed
              }}
            >
              <table
                className="font-normal max-w-[100%] sm:w-[97.6%]  md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                style={{ tableLayout: "fixed" }}
              >
                <tbody className="bg-[#F7F9FD] text-center overflow-hidden">
                  {page.map((row) => {
                    prepareRow(row);
                    return (
                      <React.Fragment key={row.id}>
                        <tr
                          {...row.getRowProps()}
                          className="relative hover:bg-white cursor-pointer transition duration-300 border-b border-gray-300 fixed-row-height"
                          onClick={() => onRowClick && onRowClick(row.original)}
                        //   onClick={() => openOrderList(row.original.id)}
                        >
                          {row.cells.map((cell, index) => (
                            <td
                              key={index}
                              {...cell.getCellProps()}
                              className={`p-2 text-[#272728] h-1212 text-[13px] font-normal ${index < row.cells.length - 1 ? "relative" : ""
                                } ${cell?.column?.Header == "Product"
                                  ? "cursor-pointer"
                                  : ""
                                }`}
                              style={{ width: cell.column.width }} // Match column width
                            >
                              {cell.render("Cell")}
                            </td>
                          ))}
                        </tr>
                      </React.Fragment>
                    );
                  })}
                  {page.length === 0 && (
                    <tr>
                      <td colSpan={"100%"}>
                        <Empty
                          className="mt-10"
                          description={t("No data available")}
                        />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* Pagination */}
            <div className="">
              <CustomPagination
                data={data?.length}
                pageIndex={pageIndex}
                pageCount={page?.length}
                canPreviousPage={pageIndex != 1 ? true : false}
                canNextPage={data?.length == pageSize ? true : false}
                gotoPage={(page) => {
                  nextPage(page);
                }}
                previousPage={() => {
                  setpageIndex(pageIndex - 1);
                }}
                nextPage={() => {
                  setpageIndex(pageIndex + 1);
                }}
                pageSize={pageSize}
                setPageSize={handlePageSizeChange}
              // setPageSize={(pageSize) => {
              //   setPageSize(pageSize);
              // }}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default InventorySaleSummaryTable;
